import React from 'react'

class Footer extends React.Component {
    componentDidMount() {
        document.querySelector(".czalone").addEventListener("click", (e) => {
            e.preventDefault();
            window.location.href=atob(e.currentTarget.attributes.getNamedItem("data-cz").value);
        });
    }
    render() {
        return (
            <footer className="wrapper style1 align-center">
                <div className="inner">
                    <h2>Contact me!</h2>
                    <ul className="icons">
                        <li><a target="_blank" href="https://www.linkedin.com/in/gadaleta/" className="icon style2 fa-linkedin"><span className="label">LinkedIn</span></a>
                        </li>
                        <li><a target="_blank" href="https://www.facebook.com/gadaleta" className="icon style2 fa-facebook"><span className="label">Facebook</span></a>
                        </li>
                        <li><a target="_blank" href="https://instagram.com/gadaabout" className="icon style2 fa-instagram"><span
                            className="label">Instagram</span></a>
                        </li>
                        <li><a href="#" data-cz="bWFpbHRvOmluZm9AZ2lvbi5zaQ" className="icon style2 fa-envelope czalone"><span className="label">Email</span></a>
                        </li>
                    </ul>
                    <p>© Giovanni Gadaleta, a.k.a. <a href="https://gion.si">Gion.si</a>. Made with <i
                        className="fa fa-heart-o" aria-hidden="true"></i> during a shitty
                        period. Design: <a href="https://html5up.net">HTML5 UP</a>.<br />
                        <a rel="license" href="http://creativecommons.org/licenses/by-nc-nd/4.0/" target="_blank">
                            Terms of use
                        </a>&nbsp;|&nbsp;
                        <a href="/privacy-policy" target="_blank">
                            Privacy Policy
                        </a></p>
                </div>
            </footer>
        )
    }
}
export default Footer